<div class="registration">

    <linear-progress :active="isRequestInProgress" />
    <div v-if="isRequestInProgress" class="registration__overlay"></div>

    <div class="registration__header text-center">
        <mom-icon class="registration__monjin-logo" svgIcon="monjin-logo-full" />
    </div>

    <div class="registration__max-width">
        <div class="registration__message">
            <div>Showcase yourself in front of multiple employers,</div>
            <div>complete your registration now</div>
        </div>
        <div class="registration__social-login-label">Create account with social profiles</div>

        <div class="registration__social">
            <google-link :iconSize="24" title="Sign up with Google" :href="googleLink" />
            <facebook-link :iconSize="24" title="Sign up with Facebook" :href="facebookLink" />
            <linkedin-link :iconSize="24" title="Sign up with LinkedIn" :href="linkedinLink" />
        </div>

        <div class="registration__divider">
            <hr class="registration__divider__line" />
            <span class="registration__divider__or">or</span>
        </div>

        <form @submit.prevent="onSubmit" class="registration__form" v-server="errors">

            <div class="registration__section registration__name">

                <input-container :dirtyForm="$v.$dirty">
                    <label class="registration__label">First Name</label>
                    <text-field class="input-field"
                        :error="hasError('firstName')"
                        v-model.trim="firstName">
                    </text-field>

                    <mom-error v-if="!$v.firstName.required">First name is required.</mom-error>
                </input-container>

                <input-container :dirtyForm="$v.$dirty">
                    <label class="registration__label">Last Name</label>
                    <text-field class="input-field"
                        :error="hasError('lastName')"
                        v-model.trim="lastName">
                    </text-field>

                    <mom-error v-if="!$v.lastName.required">Last name is required.</mom-error>
                </input-container>

            </div>

            <div class="registration__section">
                <input-container class="" :dirtyForm="$v.email.$dirty || emailTaken">
                    <label class="registration__label">Email</label>
                    <div class="registration__email">
                        <text-field class="input-field"
                            :error="hasError('email') || emailTaken"
                            v-model.trim="email"
                            @blur="checkAvailability"
                            @input="checkDone = false"
                            :disabled="isEmailDisabled">
                        </text-field>

                        <template v-if="email && !emailAvailabilityCheckFailed">
                            <progress-spinner class="registration__spinner" v-if="checking"></progress-spinner>
                            <mom-icon class="registration__email-available" width="24" height="24"
                                svgIcon="checked-circle" v-else-if="checkDone && !emailTaken"></mom-icon>
                            <mom-icon class="registration__email-unavailable" width="24" height="24"
                                svgIcon="cross-circle" v-else-if="checkDone && emailTaken"></mom-icon>
                        </template>
                    </div>
                    <mom-error v-if="!$v.email.required">Email is required.</mom-error>
                    <mom-error v-else-if="!$v.email.email">Email not in correct format.</mom-error>
                    <!-- Take to login and redirect to candidate app from login -->
                    <mom-error v-else-if="emailTaken">
                        <div class="registration__link-error">
                            This email is already registered. <a class="link link__bold" href="/internal/auth/server?redirect_hint=/@me">Click here</a> to login.
                        </div>
                    </mom-error>
                </input-container>

                <input-container :dirtyForm="$v.$dirty || !passwordCriterionSatisfied">
                    <label class="registration__label">Password</label>

                    <div class="registration__password-hint">
                        <text-field
                            :type="passwordFieldType"
                            class="registration__password-input input-field"
                            v-invalid="hasError('password') || !passwordCriterionSatisfied"
                            v-model="password"
                            @paste="disablePaste">
                        </text-field>

                        <mom-icon class="registration__view-icon" width="24" height="24"
                            svgIcon="view" @click.native="switchVisiblity('password')"></mom-icon>
                        <mom-popper trigger="click" ref="popper" :arrow="false">
                            <div class="registration__password-tips m-panel">
                                <strong>Password must include</strong>
                                <ul class="registration__password-tip-list">
                                    <li v-for="hint in passwordHints" :class="hint.satisfied ? 'satisfied' : ''">
                                        <span>{{ hint.text }}</span>
                                    </li>
                                </ul>
                            </div>
                            <mom-icon slot="anchor" class="registration__bulb-icon" width="24" height="24"
                                :key="passwordHint" svgIcon="light-bulb"></mom-icon>
                        </mom-popper>
                    </div>

                    <mom-error v-if="!$v.password.required">Password is required.</mom-error>
                    <mom-error v-else-if="!passwordCriterionSatisfied">Password criterion not satisfied.</mom-error>
                </input-container>

                <input-container :dirtyForm="$v.$dirty">
                    <label class="registration__label">Confirm Password</label>
                    <div class="registration__confirm-password">
                        <text-field
                            :type="confirmPasswordFieldType"
                            class="registration__password-input input-field"
                            :error="hasError('password2')"
                            v-model="password2"
                            @paste="disablePaste">
                        </text-field>

                        <mom-icon class="registration__confirm-view-icon" width="24" height="24"
                            svgIcon="view" @click.native="switchVisiblity('confirmPassword')"></mom-icon>
                    </div>
                    <mom-error v-if="!$v.password2.sameAs">Passwords must match.</mom-error>
                </input-container>
            </div>

            <div class="registration__section registration__terms">
                <span>By creating account, you agree to Monjin's</span>
                <a class="link" target="_blank" href="https://www.monjin.com/home/terms">Terms of Service</a>
                <span>and</span>
                <a class="link" target="_blank" href="https://www.monjin.com/privacy-policy/">Privacy Policy</a>.
            </div>

            <div class="registration__section">
                <mom-button variant="raised" class="registration__submit" type="submit" :disabled="(checking || emailTaken)">Create my account</mom-button>
                <div class="text-center">
                    <span>Already have an account?</span>
                    <a class="link link__bold" href="/internal/auth/server">Sign In</a>
                </div>
            </div>

        </form>
    </div>


</div>
